import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './components/Login';
import reportWebVitals from './reportWebVitals';
import { BannerContext } from './contexts/SettingsBannerContext';
import { MasterContext } from './contexts/MasterBannerContext';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { AuthContext } from './contexts/auth.js';
import { StyledEngineProvider } from '@mui/material/styles';

ReactDOM.render(
  <React.StrictMode>
    <AuthContext>
      <BannerContext>
        <MasterContext>
            <BrowserRouter>
              <Switch>
                <StyledEngineProvider>
                <Route path="/" component={Login}/>
                </StyledEngineProvider>
              </Switch>
            </BrowserRouter>
        </MasterContext>
      </BannerContext>
    </AuthContext>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
